import React from 'react'
import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'

import BuyerProfilesWrapper from 'agency/digital_renderer/components/BuyerProfilesWrapper'

import builderIcon from './assets/builders.svg'
import developerIcon from './assets/developers.svg'
import downsizerIcon from './assets/downsizers.svg'
import familyIcon from './assets/families.svg'
import fifoIcon from './assets/fifo.svg'
import firstHomeBuyerIcon from './assets/first-home-buyers.svg'
import internationalBuyerIcon from './assets/international.svg'
import investorIcon from './assets/investors.svg'
import professionalIcon from './assets/professionals.svg'
import regionalIcon from './assets/regional.svg'

import styles from './styles.scss'

const profileDescriptions = {
  BUILDER_RENOVATOR:
    'Renovators are looking for properties that haven’t completely capitalised on their potential value. With the goal to improve the property in a short timeline and then re-sell it for a profit. A great buyer to have interested in your property they see the potential and final dollar figure they could achieve and won’t get hung up on small imperfections or the current state of the home.',
  DEVELOPER:
    'Developers are often interested in properties located in areas experiencing good growth, that potentially accomodate other zoning applications so they can increase the number of properties in an area and successfully build high-density or high value properties on your land. A great buyer to have interested in your home they will be more focused on achieving a set figure for the home then the actual property itself.',
  DOWNSIZER:
    'Downsizers are often families or couples who no longer have the need for as much space as their current home. They are looking for somewhere smaller with a lower cost of upkeep and potentially lower maintenance fittings and gardens. Your home offers them the lifestyle they’re looking for and with a pending or complete sale of their existing home they’ll be well financed and increase your homes sale price.',
  FAMILY:
    'Families are looking for the right size house, in the right location to allow them to live comfortably, close to schools and shopping districts as well as public transport. They generally have quite well defined requirements and if they fall in love with your home they’ll become highly competitive buyers.',
  FIFO_WORKER:
    'These buyers are looking for a property to lock up and leave. They don’t want to worry about big gardens, and usually prefer extra security.',
  FIRST_HOME_BUYER:
    'In terms of layout and location your home is sure to appeal to first home buyers, looking to get themselves onto the property ladder as soon as possible they are highly motivated and encouraged to purchase with government assistance. Looking for properties with access to business districts they are competitive and know what they are looking for.',
  INTERNATIONAL_BUYER:
    'International buyers are looking for the right property to get their foot in the Australian property market, or increase their portfolio. Often less picky about suburbs and more willing to accomodate features that might turn other buyers off they are looking at more properties in a wider range of areas and will pay top dollar for the right property.',
  INVESTOR:
    'Areas that appeal to families and other outlined buyer profiles often appeal even more so to investors. Looking for properties in up and coming and established neighbourhoods that have the potential for strong rental returns or capital growth they will often be able to spend more, with finance ready than competing buyers and will increase the potential sale price of your home.',
  PROFESSIONAL_COUPLE:
    'Professional couples are looking for properties just like yours. Acceptable travel times to work and the opportunity to grow their family in time makes your property interesting to them. Strong buying power and a desire for the type of features your property offers makes them an excellent buyer to compete for your home.',
  REGIONAL_BUYER:
    'Buyers from out of area, looking to move from regional or rural areas. These buyers are competitive for the right home, happy to modify and work around a properties current features and generally looking for something easier to maintain and close to CBDs.',
}

const profileIcons = {
  BUILDER_RENOVATOR: builderIcon,
  DEVELOPER: developerIcon,
  DOWNSIZER: downsizerIcon,
  FAMILY: familyIcon,
  FIFO_WORKER: fifoIcon,
  FIRST_HOME_BUYER: firstHomeBuyerIcon,
  INTERNATIONAL_BUYER: internationalBuyerIcon,
  INVESTOR: investorIcon,
  PROFESSIONAL_COUPLE: professionalIcon,
  REGIONAL_BUYER: regionalIcon,
}

const renderProfiles = buyerProfiles => buyerProfiles.map((profile) => {
  const profileDescription = profileDescriptions[profile.key]

  if (profileDescription){
    return (
      <Fade key={profile.key}>
        <div className={styles.profile}>
          <span className={styles.iconHolder}>
            <img alt="Icon" src={profileIcons[profile.key]} />
          </span>

          <div className={styles.text}>
            <span className={styles.profileTitle}>{profile.title}</span>
            <span className={styles.profileDescription}>{profileDescription}</span>
          </div>
        </div>
      </Fade>
    )
  }

  return null
})

const BuyerProfiles = (props) => {
  const { campaign } = props

  return (
    <BuyerProfilesWrapper
      campaign={campaign}
      render={({ buyerProfiles }) => (
        <div className={styles.root}>
          <h4>Buyer Profiles</h4>

          <p className={styles.intro}>
            Based on your property&apos;s current condition, the availability of similar properties and current
            demographic trends, we believe your property will appeal to the following buyers and we will shape our
            marketing and plan around this.
          </p>

          {renderProfiles(buyerProfiles)}
        </div>
      )}
    />
  )
}

BuyerProfiles.propTypes = {
  campaign: PropTypes.object.isRequired,
}

export default BuyerProfiles
